/**
 * Returns the Vue Router route object for a task's Kanban view. Used as the
 * synthetic `lastRoute` for share-intent arrivals — without this, the back
 * button has no destination because the user never visited TaskBoard forward.
 *
 * Defaults to Kanban (the canonical TaskBoard view); future enhancement may
 * encode the source surface (gantt/list/schedule) in the URL and dispatch
 * accordingly.
 *
 * @param {{ taskTypeId: string }} task
 * @param {string} facilityId
 * @returns {{ name: string, params: { id: string, taskTypeId: string } }}
 */
export function synthesizeKanbanRoute(task, facilityId) {
  return {
    name: 'kanban',
    params: {
      id: facilityId,
      taskTypeId: task.taskTypeId,
    },
  };
}
